import "./Heading.css"

const Heading = ({ nth, eventDate, eventLocation }) => {

    return (
        <div className="past_geb_head op_top_container">
            <div className="pg_title op_top_title">
                GEB, <span className="colored_pg_title">{nth} EDITION</span>
            </div>
            <div className="pg_subtitle1 op_top_subtitle op_top_color_subtitle">
                GLOBAL ENTREPRENEURSHIP BOOTCAMP
            </div>
            <div className="pg_subtitle2 op_top_subtitle">
                {eventDate} {eventLocation}
            </div>
        </div>
    );
};

export default Heading;